<script>
import apiServices from '@/services/yungol-services'
import urlImg from '@/assets/icons/shareLink.svg'
const XLSX = require("xlsx");
export default {
  template: `<div class="buttons is-justify-end" style='width: 100%; height: 100%; margin: auto;'>
  <button class="button is-danger" v-on:click="deleteRelation()">
      <span v-tooltip="'Eliminar'" class="icon">
        <i class="material-icons">delete_forever</i>
      </span>
  </button>
  <button class="button is-dark" v-on:click="sendEmail()">
      <span v-tooltip="'Enviar Correo'" class="icon">
        <i class="material-icons">email</i>
      </span>
  </button>
  <button class="button is-link" v-on:click="downloadResponses()">
      <span v-tooltip="'Descargar Respuestas'" class="icon">
        <i class="material-icons">cloud_download</i>
      </span>
  </button>
  <button class="button is-link" v-on:click='linkSurvey()'>
      <span v-tooltip="'Link Encuesta'" class="icon">
        <i class="material-icons">share</i>
      </span>
  </button>
  </div>`,
  data(){
    return {}
  },
  methods:{
    // Actions
    async deleteRelation(){
      const config = {
        title: '¿Estás seguro?',
        text: "Al eliminar no se podrá recuperar la relación después",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#de5b5b',
        confirmButtonText: 'Sí, eliminar'
      };
      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const result = await apiServices.delete(`/relacion/${this.params.value}`);
            if (result.data) {
              await this.$swal({
                text: 'Relación eliminada correctamente.',
                icon: 'success',
                showConfirmButton: false,
                timer: 1700
              })
              this.params.api.applyTransaction({
                remove: [this.params.node.data],
              });
            }
          } catch (err) {
            await this.$swal({
              text: 'Error al eliminar la relación.',
              icon: 'error',
              showConfirmButton: false,
              timer: 1700
            })
            console.log(err)
          }
        }
      });
    },
    async sendEmail() {
      let result;
      const d = {
        id: this.params.value,
      };
      try {
        result = await apiServices.post(`/enviarcorreo`, d);
        // this.datafile = result.data;
        if (result.data) {
          await this.$store.dispatch("notify", {
            message: "Correo enviado exitosamente.",
          });
        }
        await this.params.getRelations();
      } catch (error) {
        await this.$store.dispatch("notify", {
          message: "Error al enviar el correo.",
          type: "is-danger",
          duration: 4000,
          position: "top-right",
        });
        console.log(error);
      }
    },
    async downloadResponses() {
      const d = [this.params.data.responses, this.params.data.evaluador.nombre]

      if (d[0]) {
        this.dataToExport = [];
        this.dataToExport.push(d[0]);

        // Se parsea el valor boolean a texto
        this.dataToExport[0].agree ? this.dataToExport[0].agree = "Si" : this.dataToExport[0].agree = "No"

        //  Asignamos la información necesaria a nuevas variables
        let name = "LD-Respuestas " + d[1];
        //  Se agrega la data al libro de excel
        const ws = XLSX.utils.json_to_sheet(this.dataToExport);

        //  Se configura el tamaño de cada columna
        ws["!cols"] = this.params.widthCols(this.dataToExport)

        //  Se crea el libro con la data agregada, se le da un nombre y finalizando se descarga
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Respuestas");
        const nombreArchivo = name + ".xlsx";
        XLSX.writeFile(wb, nombreArchivo);

      } else {
        await this.$store.dispatch("notify", {
          message: `Este Usuario no tiene respuestas`,
          type: "is-danger",
        });
      }
    },
    linkSurvey: function () {
      const baseurl = window.location.host
      const ruta = `<span class='is-size-6'>${baseurl}/encuesta/${this.params.value}</span>`;

      const config = {
        title: 'Link de la encuesta',
        html: ruta,
        imageUrl: urlImg,
        imageWidth: 180,
        imageHeight: 180,
        imageAlt: 'https://icons8.com/icon/109462/share',
        customClass: {
          icon: 'no-border'
        },
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonColor: '#a8c2ef',
        cancelButtonText: 'Cerrar'
      };
      this.$swal(config)
    },
  }
}
</script>

<style lang='scss'>
.no-border {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/components/buttonsActionRelation.vue